import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { MarkSchemeStepWrapper } from "./MarkSchemeStepWrapper";

export const MarkSchemeViewDialog = ({ open, setOpen, question }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      slotProps={{
        paper: {
          sx: {
            backgroundImage: "none",
            width: "80% !important",
            maxWidth: "100% !important",
          },
        },
      }}
    >
      <DialogTitle>Mark Scheme</DialogTitle>
      <DialogContent>
        <MarkSchemeStepWrapper
          markScheme={question?.markScheme}
          question={question}
          readOnly
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant={"contained"}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
